export const QUERY_KEYS = {
  USER: 'user',
  RECOVERY_CODE: 'code'
};

export const BACKEND_KEYS = {
  SIGNUP: 'auth/signup',
  SIGNIN: 'auth/signin',
  ACTIVATE_ACCOUNT: 'auth/activate',
  PASSWORD_RESET: 'auth/reset-password',
  FORGOT_PASSWORD: 'auth/password-recovery',
  CHECK_RECOVERY_CODE: 'auth/check-password-recovery-code',
  RESEND_RECOVERY_CODE: 'auth/resend-password-recovery',
  RESEND_ACTIVATION_CODE: 'auth/resend-activation',
  ME: 'auth/me',
  LOGOUT: 'auth/logout',
  USER_INFO: 'user/has-portal',
  CHANGE_EMAIL: 'user/change-email',
  CHANGE_PASSWORD: 'user/change-password',
  DELETE_ACCOUNT: 'user/delete-account',
  RESEND_EMAIL_CONFIRMATION: 'user/resend-email-confirmation',
  CONFIRM_EMAIL: 'user/confirm-email',
  CHECKOUT_SESSION: 'stripe/session',
  GET_USER_PORTAL_URL: 'stripe/customer-portal',
  FREE_TRIAL: 'stripe/free-trial',
  GET_PLAN_PRICE: 'stripe/price',
  REVIEW: 'review',
  ADMIN_USERS: 'admin/users',
  REDEEM_INVITE: 'user/redeem-invite',
  INVITE_PRO: 'admin/invite-pro',
  USER_WEBHOOKS: 'user/webhooks',
  LOGOUT_ALL: 'user/logout-all',
  MFA_SETUP: 'auth/mfa/setup',
  MFA_ENABLE: 'auth/mfa/enable',
  MFA_DISABLE: 'auth/mfa/disable',
  MFA_VERIFY: 'auth/mfa/verify',
  MFA_STATUS: 'auth/mfa/status',
  MFA_EMAIL_SETUP: 'auth/mfa/email/setup',
  MFA_EMAIL_ENABLE: 'auth/mfa/email/enable',
  MFA_EMAIL_DISABLE: 'auth/mfa/email/disable',
  MFA_EMAIL_SEND: 'auth/mfa/email/send',
  MFA_PUSH_ENABLE: 'auth/mfa/push/enable',
  MFA_PUSH_DISABLE: 'auth/mfa/push/disable',
  MFA_PUSH_SEND: 'auth/mfa/push/send',
  MFA_PUSH_RESPOND: 'auth/mfa/push/respond',
  MFA_PUSH_STATUS: 'auth/mfa/push/status',
  MFA_PUSH_CHECK_SUBS: 'auth/mfa/push/check-subscriptions',
  PUSH_SUBSCRIBE: 'push/subscribe',
  PUSH_VAPID_KEY: 'push/vapid-key',
  COMPANY: 'company',
  QR_CHECKIN: 'review',
  DEVELOPER_API_KEYS: 'developer/api-keys',
  DEVELOPER_API_KEY_REGENERATE: 'developer/api-keys/regenerate',
  OAUTH_VALIDATE: 'oauth/validate',
  OAUTH_AUTHORIZE: 'oauth/authorize',
  OAUTH_TOKEN: 'oauth/token',
  OAUTH_APPS: 'developer/oauth/apps'
};

export const ROUTER_KEYS = {
  ROOT: '/',
  AUTH: '/auth/*',
  SIGNUP: '/signup',
  ACTIVATE_ACCOUNT: '/activate-account',
  PASSWORD_RECOVERY: '/password-recovery',
  SIGNIN: '/signin',
  FORGOT_PASSWORD: '/forgot-password',
  CREATE_NEW_PASSWORD: '/create-new-password',
  PASSWORD_UPDATED: '/password-updated',
  SETTINGS: '/settings',
  PRICING: '/pricing',
  DASHBOARD: '/dashboard',
  REVIEW: '/review/:slug',
  REVIEW_ADMIN: '/review/:slug/admin',
  TEAMS: '/teams',
  TEAM: '/team/:id',
  TEAM_ADMIN: '/team/:id/admin',
  TEAM_JOIN: '/team/join/:inviteCode',
  DOCS: '/docs',
  CONTACT: '/contact',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  ADMIN: '/admin',
  ADMIN_CHANGELOG: '/admin/changelog',
  INVITE: '/invite/:token',
  MFA_APPROVE: '/mfa/approve/:challengeId',
  COMPANY: '/company',
  COMPANY_SUBSITE: '/c/:companySlug',
  COMPANY_SUBSITE_REVIEW: '/c/:companySlug/review/:slug',
  COMPANY_SUBSITE_REVIEW_ADMIN: '/c/:companySlug/review/:slug/admin',
  QR_CHECKIN: '/qr/:token',
  DEVELOPER: '/developer',
  OAUTH_AUTHORIZE: '/oauth/authorize',
  NOT_FOUND: '/*'
};

export const ROUTER_LINKS = {
  ROOT: '/',
  SIGNUP: '/auth/signup',
  ACTIVATE_ACCOUNT: '/auth/activate-account',
  PASSWORD_RECOVERY: '/auth/password-recovery',
  SIGNIN: '/auth/signin',
  FORGOT_PASSWORD: '/auth/forgot-password',
  CREATE_NEW_PASSWORD: '/auth/create-new-password',
  PASSWORD_UPDATED: '/auth/password-updated',
  SETTINGS: '/settings',
  PRICING: '/pricing',
  DASHBOARD: '/dashboard',
  REVIEW: '/review',
  TEAMS: '/teams',
  DOCS: '/docs',
  CONTACT: '/contact',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  ADMIN: '/admin',
  ADMIN_CHANGELOG: '/admin/changelog',
  COMPANY: '/company',
  DEVELOPER: '/developer'
};
